import instanceAuth from '@network/auth';

export interface IAnswer {
  id: number;
  content: string;
  metaData?: any;
}

export interface IQuestion {
  id: number;
  title: string;
  type: string;
  topic?: string;
  answers: IAnswer[];
}

export interface IMilestoneDetail {
  title: string;
  merchantId: number;
  tagIds: number[];
  numberOfQuestions: number;
  questions: IQuestion[];
  tagObjects: any[];
}

export async function getMilestoneQuestions(milestoneId: number): Promise<IMilestoneDetail> {
  const instance = instanceAuth();
  const res = await instance.get(`/users/milestones/${milestoneId}/questions`);
  return res.data.data;
}

export async function getMilestoneById(milestoneId: number): Promise<IMilestoneDetail> {
  const instance = instanceAuth();
  const res = await instance.get(`/users/milestones/${milestoneId}/questions`);
  return res.data.data;
}

export async function submitAnswers(milestoneId: number, answers: { questionId: number; answerId: number }[]): Promise<any> {
  const instance = instanceAuth();
  const res = await instance.post(`/users/milestones/${milestoneId}/submit-answers`, { answers });
  return res.data.data;
}

export async function getMilestoneCompletionStatus(milestoneId: number): Promise<{ milestoneId: number; hasAnswered: boolean }> {
  const instance = instanceAuth();
  const res = await instance.get(`/users/milestones/${milestoneId}/completion-status`);
  return res.data.data;
}

export async function getCompletedMilestones(): Promise<{ completedMilestones: number[] }> {
  const instance = instanceAuth();
  const res = await instance.get('/users/completed-milestones');
  return res.data.data;
}